<template>

    <div class="segmenter groupable">
        <div v-if="rules.length > 1" class="segmenter-header">
            <v-select class="w-200" size="sm" :model="op || 'and'" @input="op = $event">
                <option value="and">All rules must match...</option>
                <option value="or">Any rule can match...</option>
            </v-select>
        </div>
        <div v-if="rules.length" class="segmenter-body">
            <v-rule-group v-for="group in rules" :key="group.id" :group="group" />
        </div>
        <div class="segmenter-footer">
            <v-button-toolbar size="sm">
                <v-button size="sm" btn-style="secondary" @click.native="addRuleGroup">Add Rule Group</v-button>
                <v-button size="sm" btn-style="secondary" @click.native="$emit('search')">Search Customers</v-button>
            </v-button-toolbar>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .segmenter {
        background: #fff;
        &.groupable {
            border: 1px solid $color-rule;
            border-radius: 3px;
            margin-bottom: 10px;
            .segmenter-header {
                border-bottom: 1px solid $color-rule;
                padding: 15px;
            }
            .segmenter-body {
                border-bottom: 1px solid $color-rule;
                padding: 15px;
            }
            .segmenter-footer {
                display: flex;
                padding: 15px;
            }
        }
    }

</style>

<script>

import RuleGroup from './rules/RuleGroup';

export default {

    components: {
        'v-rule-group': RuleGroup,
    },

    props: {
        model: {
            type: Object,
        },
    },

    data() {
        return {
            op: this.$store.getters['segmenter/op'],
        }
    },

    mounted() {
        this.$store.commit('segmenter/setType', 'segment');
        this.$store.commit('segmenter/setModel', this.model);
        if (this.model) {
            this.$store.commit('segmenter/setOp', this.model.op || 'and');
            this.$store.commit('segmenter/setRules', this.model.rules);
            if (!this.model.rules.length) {
                this.$store.commit('segmenter/addRuleGroup');
            }
        } else {
            this.$store.commit('segmenter/setOp', 'and');
            this.$store.commit('segmenter/setRules', []);
            this.$store.commit('segmenter/addRuleGroup');
        }
    },

    computed: {

        rules() {
            return this.$store.getters['segmenter/rules'];
        },

    },

    watch: {

        op(val) {
            this.$store.commit('segmenter/setOp', val);
        },

    },

    methods: {

        addRuleGroup() {
            this.$store.commit('segmenter/addRuleGroup');
        },

    },

}

</script>
